import React from "react";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import {ReusablePeriodFilter} from "../../Utils/EpharmHeadings/ReusablePeriodFilter";
import {EnhancedTableHead, EnhancedTableToolbar, MuiPagination, MuiPaper} from "../../Utils/Tables/CustomTable";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ReusableDialog from "../../Utils/Dialog/ReusableDialog";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Label from "../../Utils/FormInputs/Label";
import TextField from "../../Utils/FormInputs/TextField";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from '../../Redux/Actions/SnackbarActions/SnackbarActions'
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import {useManageBank} from "./CustomHooks/useManageBank";
import {Link} from 'react-router-dom';

const headData = [
    {id: 'bank', numeric: false, disablePadding: false, label: 'Bank Name'},
    {id: 'branch', numeric: false, disablePadding: false, label: 'Branch'},
    {id: 'accNumber', numeric: false, disablePadding: false, label: 'Account No.'},
    {id: 'accName', numeric: false, disablePadding: false, label: 'Account Name'},
    {id: 'balance', numeric: false, disablePadding: false, label: 'Opening Balance'},
    {id: 'action', numeric: false, disablePadding: false, label: 'Action'},
];

const ManageBank = ({actions, snackbars}) => {
    const {
        openDialog, handleCloseDialog, handleOpenDialog, period, handleChangePeriod, inputType, date,
        handleChangeDate, year, handleChangeYear, data,handleSubmit,
        state, handleChange, closeSnackbar, submitted, isSubmitted,
        page, rowsPerPage, handleChangeRowsPerPage, handleChangePage, loading,
    } = useManageBank(actions);
    const {from_date, to_date} = date
    const {open, variant, message} = snackbars;
    const {account_name, branch, account_no, opening_balance, bank_name} = state
    return (
        <div className='journals'>
            <ReusableDashboardHeader component="Bank" heading="Banks"
                                     subHeading="Banks" link="/banks"/>
            <ReusablePeriodFilter period={period} handleChangePeriod={handleChangePeriod} inputType={inputType}
                                  from_date={from_date} to_date={to_date} handleChangeDate={handleChangeDate}
                                  year={year}
                                  handleChangeYear={handleChangeYear} handleFilter={() => {
            }}>
                <div className='text-right'>
                    <button onClick={handleOpenDialog} className='btn btn-sm pharmacy-info-btn'>New Bank</button>
                </div>
            </ReusablePeriodFilter>
            <ReusableDialog handleSubmit={handleSubmit} openDialog={openDialog}
                            handleClose={handleCloseDialog} message='New Bank' isSubmitted={isSubmitted}>
                <Form.Group as={Row}>
                    <Label name='Bank Name' type column sm={3} />
                    <Col sm={7}>
                        <TextField type='text' value={bank_name} name='bank_name' onChange={handleChange}/>
                        {submitted && !bank_name ? <div className='invalid-text'>Bank Name is required</div> : null}
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Label name='Branch'  column sm={3} />
                    <Col sm={7}>
                        <TextField type='text' value={branch} name='branch' onChange={handleChange}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Label name='Account No.' type column sm={3} />
                    <Col sm={7}>
                        <TextField type='text' value={account_no} name='account_no' onChange={handleChange}/>
                        {submitted && !account_no ? <div className='invalid-text'>Account No. is required</div> : null}
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Label name='Account Name.' type column sm={3} />
                    <Col sm={7}>
                        <TextField type='text' value={account_name} name='account_name' onChange={handleChange}/>
                        {submitted && !account_name ? <div className='invalid-text'>Account Name is required</div> : null}
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Label name='Opening Bal.'  column sm={3} />
                    <Col sm={7}>
                        <TextField type='number' value={opening_balance} name='opening_balance' onChange={handleChange}/>
                    </Col>
                </Form.Group>
            </ReusableDialog>
            <PharmacySnackbar handleCloseBar={closeSnackbar} variant={variant} open={open} message={message}/>
            <MuiPaper>
                <EnhancedTableToolbar title='Banks'/>
                <TableContainer>
                    <Table
                        aria-labelledby="tableTitle"
                        size='medium'
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead headCells={headData}/>
                        {loading ? <TableBody><TableRow>
                            <TableCell colSpan="5" align="center"><img src="/images/listPreloader.gif"
                                                                       alt="loader"
                                                                       style={{width: '5%'}}/></TableCell>
                        </TableRow></TableBody> : data.length > 0 ?
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((d, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={d.bank_id}
                                                className='mui-table-row'>
                                                <TableCell component="th" scope="row" padding="default"
                                                           className='mui-table-cell'>
                                                    {d.bank_name}
                                                </TableCell>
                                                <TableCell>
                                                    {d.branch}
                                                </TableCell>
                                                <TableCell>
                                                    {d.account_number}
                                                </TableCell>
                                                <TableCell>
                                                    {d.account_name}
                                                </TableCell>
                                                <TableCell>
                                                    {d.opening_balance}
                                                </TableCell>
                                                <TableCell>
                                                    <Link to={{pathname:`/editbank/${d.bank_id}`}}>
                                                    <button className='btn btn-sm pharmacy-info-btn'>Edit</button></Link>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                            : <TableBody><TableRow>
                                <TableCell colSpan="5" align="center">No records found</TableCell>
                            </TableRow></TableBody>}
                    </Table>
                </TableContainer>
                <MuiPagination data={data} rowsPerPage={rowsPerPage} page={page}
                               handleChangeRowsPerPage={handleChangeRowsPerPage}
                               handleChangePage={handleChangePage} rows={[10, 20, 30, 40, 50]} colSpan={3}/>
            </MuiPaper>
        </div>
    )
}

function mapStateToProps(state) {
    const {snackbars} = state;
    return {snackbars}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageBank)